import React, { Component } from "react";
import { Link } from "react-router-dom";

export default class TypeSelectorModal extends Component {
  render() {
    return (
      this.props.showTypeSelectorModal && (
        <React.Fragment>
          <div className="section-steps__edit-container showResume">
            <div className="container">
              <div className="row">
                <div className="col-md-1" />
                <div className="col-xs-12 col-md-10">
                  <div className="section-steps__edit-content">
                    <div className="section-steps__resume-header">
                      <div className="resume-header__title">
                        <span>Datos de tu Lexus</span>
                        <span className="resume-header__link">
                          {this.props.carInfo ? (
                            <Link
                              to="/carRegistration"
                              className="link link--red"
                              onClick={() => {
                                this.props.modalTypeSelectorToggle();
                                this.props.resetStateTo2();
                              }}
                            >
                              Modificar
                            </Link>
                          ) : (
                            <Link
                              to="/carRegistration"
                              className="link link--red"
                              onClick={() => {
                                this.props.modalTypeSelectorToggle();
                                this.props.resetStateTo2();
                              }}
                            >
                              Modificar
                            </Link>
                          )}
                        </span>
                      </div>
                      <div
                        className="resume-header__close"
                        onClick={this.props.modalTypeSelectorToggle}
                      >
                        X
                      </div>
                    </div>
                    <div className="section-steps__resume-content">
                      {this.props.plate ? (
                        <div className="resume-header__block">
                          <div className="resume-header__block-title">
                            Matrícula
                          </div>
                          <div className="resume-header__block-info">
                            {this.props.plate}
                          </div>
                        </div>
                      ) : null}

                      <div className="resume-header__block">
                        <div className="resume-header__block-title">Modelo</div>
                        <div className="resume-header__block-info">
                          {this.props.selectedModel.name}
                        </div>
                      </div>

                      <div className="resume-header__block">
                        <div className="resume-header__block-title">Motor</div>
                        <div className="resume-header__block-info">
                          {this.props.carInfo
                            ? this.props.carInfo.engineName
                            : this.props.engineNameSelected}
                        </div>
                      </div>

                      <div className="resume-header__block">
                        <div className="resume-header__block-title">
                          Combustible
                        </div>
                        <div className="resume-header__block-info">
                          {this.props.carInfo
                            ? this.props.carInfo.fuel
                            : this.props.fuelSelected}
                        </div>
                      </div>

                      <div className="resume-header__block">
                        <div className="resume-header__block-title">
                          Tipo de cambio
                        </div>
                        <div className="resume-header__block-info">
                          {this.props.carInfo
                            ? this.props.carInfo.gearBoxName
                            : this.props.gearBoxNameSelected}
                        </div>
                      </div>

                      <div className="resume-header__block">
                        <div className="resume-header__block-title">
                          Años o Nº de kilómetros
                        </div>
                        <div className="resume-header__block-info">
                          {this.props.distanceSelected}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )
    );
  }
}
